import { apiRequest } from './client'
import type {
  SilkApplyCashWithdrawalBody,
  SilkApplyPointsWithdrawalBody,
  SilkConvertRevenueBody,
  SilkConvertRevenueResponse,
  SilkRevenueOverview,
  SilkRevenueRecordList,
  SilkRevenueSource,
  SilkRevenueStatus,
  SilkWithdrawal,
  SilkWithdrawalList,
  SilkWithdrawalStatus,
} from './types'

export const revenueApi = {
  overview: () => apiRequest<SilkRevenueOverview>('/api/v1/revenue/summary'),

  records: (params?: {
    source?: SilkRevenueSource
    status?: SilkRevenueStatus
    limit?: number
    offset?: number
  }) => apiRequest<SilkRevenueRecordList>('/api/v1/revenue/records', { query: params }),

  convert: (body: SilkConvertRevenueBody) =>
    apiRequest<SilkConvertRevenueResponse>('/api/v1/revenue/convert', {
      method: 'POST',
      body,
    }),

  /* ----- withdrawals ----- */

  applyCashWithdrawal: (body: SilkApplyCashWithdrawalBody) =>
    apiRequest<SilkWithdrawal>('/api/v1/revenue/withdrawals/cash', {
      method: 'POST',
      body,
    }),

  applyPointsWithdrawal: (body: SilkApplyPointsWithdrawalBody) =>
    apiRequest<SilkWithdrawal>('/api/v1/revenue/withdrawals/points', {
      method: 'POST',
      body,
    }),

  listWithdrawals: (params?: {
    status?: SilkWithdrawalStatus
    limit?: number
    offset?: number
  }) =>
    apiRequest<SilkWithdrawalList>('/api/v1/revenue/withdrawals', {
      query: params,
    }),

  cancelWithdrawal: (id: number) =>
    apiRequest<SilkWithdrawal>(`/api/v1/revenue/withdrawals/${id}/cancel`, {
      method: 'POST',
    }),
}
